// This file is used for maintain and manage API services.
(function() {
  'use strict';
  angular.module('obex').
  factory('providers', ['$http', 'obexConstant', 'authService',
    function($http, obexConstant, authService) {
      return {
        addProvider(provider) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const postData = {
              Id: provider.Id,
              Name: provider.Name,
              Code: provider.Code,
              IATACode: provider.IATACode,
              LoginTitle: provider.LoginTitle,
              ImageLink: provider.ImageLink,
              Login2Code: provider.Login2Code,
              Login2Title: provider.Login2Title,
              Login3Code: provider.Login3Code,
              Login3Title: provider.Login3Title,
              ProviderType: provider.ProviderType,
            };
            return $http.post(obexConstant.urlProvider, postData, {
              headers: authHeader,
            });
          });
        },
        getProviders() {
          return authService.getAuthorizationHeader().then(authHeader => {
            return $http.get(obexConstant.urlProvider, {
              headers: authHeader,
            });
          });
        },
        getProvidersByAdmin() {
          const url = obexConstant.urlProvider+'/admin/';
          return authService.getAuthorizationHeader().then(authHeader => {
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        getProviderById(id) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlProvider}/${id}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        updateProvider(id, provider) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlProvider}/${id}`;
            const putData = {
              Id: provider.Id,
              Name: provider.Name,
              Code: provider.Code,
              IATACode: provider.IATACode,
              LoginTitle: provider.LoginTitle,
              ImageLink: provider.ImageLink,
              Login2Code: provider.Login2Code,
              Login2Title: provider.Login2Title,
              Login3Code: provider.Login3Code,
              Login3Title: provider.Login3Title,
              ProviderType: provider.ProviderType,
            };
            return $http.put(url, putData, {
              headers: authHeader,
            });
          });
        },
        deleteProvider(id) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlProvider}/${id}`;
            return $http.delete(url, {
              headers: authHeader,
            });
          });
        },
        // Send raw image to node backend for uploading and processing
        uploadImage(img) {
          return authService.getAuthorizationHeader().then(({Authorization}) => {
          var fd = new FormData();
          fd.append('image', img);
          return $http.post('/provider/img', fd, {
            headers: {
              'Content-Type': undefined,
              Authorization
            },
            transformRequest: angular.identity,
          });
        })
        },
        // Send raw image to node backend for uploading and processing
        deleteImage(img) {
          const postData = { id: img };
          return  $http({
            method: 'DELETE',
            url: '/provider/img',
            data: postData,
            headers: {'Content-Type': 'application/json;charset=utf-8'}
          })
        },
        // Retrieve url for a transformed image
        transformImage(filename) {
          const postData = { id: filename };
          return $http.post('/provider/img/transform', postData);
        },
      };
    },
  ]);
})();


// WEBPACK FOOTER //
// ./client/js/services/providers.service.js